import { Input } from '@angular/core';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { AgentService } from '../services/agent.service';

export class AgentTrainingHandlerComponent extends BaseComponent<AgentService> {
  constructor(agentService: AgentService) {
    super(agentService);
  }

  public onAddTrainingDetail(event) {
    this.service.addTrainingDetail();
  }
}
